module.exports = __webpack_public_path__ + "img/svg/freematch.5e738ccd0151c722baa1219808079953.svg";